class UserNotificationEmailPermission
{
    // Admin privileges, other permissions are not checked
    static ROOT = 'user_notification_email.*';

    // Enabled flag: if not present, access denied on any operation. Not required for root
    static _ENABLED = 'user_notification_email._m';

    // Access archive
    static ACCESS_ARCHIVE = 'user_notification_email.access.archive';

    // Access unverified
    static ACCESS_UNVERIFIED = 'user_notification_email.access.unverified';

    // Create new unverified user verification email
    static CREATE = 'user_notification_email.create';

    // Create new verified user verification email
    static CREATE_VERIFIED = 'user_notification_email.create.verified';

    // Update user notification email info
    static UPDATE = 'user_notification_email.update';

    // Create verification code for email
    static VERIFICATION_FLOW = 'user_notification_email.verification.flow';

    // Manually manage verification of notification email
    static VERIFICATION_MANAGE = 'user_notification_email.verification.manage';

    // Archive notification email
    static ARCHIVE = 'user_notification_email.archive';
}

export default UserNotificationEmailPermission;
